import { forwardRef, HeadingProps, Heading } from '@chakra-ui/react'

export interface PageHeadingProps extends HeadingProps {}

export const PageHeading = forwardRef<PageHeadingProps, 'h1'>((props, ref) => (
  <Heading ref={ref} as="h1" fontSize="xl" my={4} {...props} />
))
